module.exports = __webpack_public_path__ + "img/move02.181779cd.jpg";